export const PLACEHOLDER = Object.freeze({
  'first-snow': '첫눈온방에서 검색해보세요',
  'large-snow': '함박눈방에서 검색해보세요',
  'permanent-snow': '만년설방에서 검색해보세요',
  'exam-review': '시험 후기 게시판에서 검색해보세요',
  besookt: '베숙트에서 검색해보세요',
  board: '전체 게시판 내 검색',
  post: '전체 게시판 내 검색',
});
